import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mct-container"
};
const _hoisted_2 = {
  class: "mct-content-container"
};
const _hoisted_3 = {
  class: "mct-left-nav"
};
const _hoisted_4 = {
  class: "mct-content"
};
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserDefaultSettingStore } from '@/store/user';
import MctHeader from '@/components/mct-header/index.vue';
import MctLeftNav from '@/components/MctLeftNav.vue';
import SnoozeDialog from '@/components/snooze-dialog/index.vue';
import SetTimerDialog from '@/components/set-timer-dialog/index.vue';
import MaintenanceDialog from '@/components/maintenance-dialog/index.vue';
import ManualTestTrigger from '@/components/manual-test-trigger/index.vue';
import ManualTestDialog from '@/components/manual-test-dialog/index.vue';
import DetailStatusDialog from '@/components/detail-status-dialog/index.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'MctView',
  setup(__props) {
    const userDefaultSettingStore = useUserDefaultSettingStore();
    const {
      preferences
    } = storeToRefs(userDefaultSettingStore);
    onMounted(() => {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const userTheme = preferences.value.theme;
      const handleThemeChange = event => {
        if (userTheme === 'device-theme') {
          if (event.matches) {
            console.log('Change to dark theme');
            document.documentElement.classList.add('dark-theme');
          } else {
            console.log('Change to light theme');
            document.documentElement.classList.remove('dark-theme');
          }
        }
      };
      mediaQuery.addEventListener('change', handleThemeChange);
      if (userTheme === 'device-theme' || !userTheme) {
        if (mediaQuery.matches) {
          document.documentElement.classList.add('dark-theme');
        } else {
          document.documentElement.classList.remove('dark-theme');
        }
      } else {
        document.documentElement.className = userTheme;
      }
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(MctHeader), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(MctLeftNav)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_view)])]), _createVNode(MaintenanceDialog), _createVNode(SnoozeDialog), _createVNode(SetTimerDialog), _createVNode(ManualTestTrigger), _createVNode(ManualTestDialog), _createVNode(DetailStatusDialog)]);
    };
  }
});